export default {"src":"/_next/static/media/ic_message_check.1e932e68.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};